var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"className":"group"}},[_c('lottie-animation',{attrs:{"path":'./json/BarGraph_01.json',"loop":false,"speed":1}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }